<template>
  <div>
    <price :sellPrice="sellPrice" :fullPrice="fullPrice" :badge="badge" />
    <add-cart class="add-cart" :availableAmount="availableAmount" />
  </div>
</template>

<script setup lang="ts">
import Price from '../common/price.vue';
import AddCart from '../common/add-cart.vue';
import type { IBadge } from '../../models/badge';

interface Props {
  sellPrice: number;
  fullPrice?: number;
  badge?: IBadge | null;
  availableAmount: number;
}

defineProps<Props>();
</script>
